// extracted by mini-css-extract-plugin
module.exports = {"pill":"pill_pill__8woz0","details-link":"pill_details-link__gND9y","label":"pill_label__IcxDD"};